import React, { useState, useEffect } from 'react';
import { LifeLine } from "react-loading-indicators";
import { v4 as uuidv4 } from 'uuid';
import Header from '../components/Header';
import MyText from '../components/MyText';
import Button from '../components/Button';
import Handler from '../services';
import { useLocation, useNavigate } from 'react-router-dom';
import tick from "../assets/tick.svg";
import cross from "../assets/crocetta.svg";
import cart from "../assets/cart.svg";
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import { Container, Row, Col } from 'react-grid-system';

export default function Pacchetto() {
    const { userInfo } = useAuth();
    const { state } = useLocation();
    const { idProdotto, idOrdine, idRiga, client, cat, descrizione, riepilogo, importo, name } = state;
    const pacchetto = true;
    const idClinica = userInfo.id;
    const nomeClinica = userInfo.nome_clinica;
    // const importo = state.importo;
    const handler = Handler();
    const navigate = useNavigate();
    const [pending, setPending] = useState(false);
    const [redScreen, setRedScreen] = useState(false);
    const [greenScreen, setGreenScreen] = useState(false);
    const [prestaError, setPrestaError] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const sendRequest = async () => {
        const newId = uuidv4();
        const params = { id: newId, idClinica, idCliente: client.id, importo }
        setPending(true);
        try {
            let apiKey = await handler.genera(pacchetto, params);
            let body = {
                id: newId, 
                client,
                importo,
                idClinica,
                nomeClinica,
                idProdotto,
                idOrdine,
                idRiga,
                apiKey,
                pacchetto
            }
            var pushRes = await handler.sendNotifications(body);
            if (!pushRes || pushRes.status !== 200 || !pushRes.data || pushRes.data.errors?.length > 0) {
                toast.error("Errore nell'invio della notifica. il cliente potrebbe aver disabilitato le notifiche push o potrebbe esserci un problema di connessione.");
                return;
            }
            let res = await handler.getStato(pacchetto, { id: newId })
            if (!res) {
                toast.error("Errore nel recupero dello stato della richiesta.");
                return;
            }
            if (res.stato === "Scaduta" || res.statusCode === 400) {
                toast.error('Richiesta scaduta');
            } else if (res.stato === "Confermato") {
                setGreenScreen(true);
            } else if (res.stato === "Rifiutato") {
                setRedScreen(true);
            } else if (res.stato === "Errore") {
                setRedScreen(true);
                setPrestaError(true);
            } else {
                toast.error("Stato della richiesta non riconosciuto.");
            }
        } catch (err) {
            toast.error("Si è verificato un errore sconosciuto.");
        } finally {
            setPending(false)
        }
    }

    const removeHTMLTags = (str) => {
        return str.replace(/<\/?[^>]+(>|$)/g, "");
    }

    if (pending) {
        return (
            <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <LifeLine color="#282d68" size="large" text="Aspettando conferma dall'utente..." textColor="" />
            </div>
        )
    }

    if (redScreen) {
        return (
            <div style={{ ...styles.redContainer, backgroundColor: "#FF00007F" }}>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <MyText style={{ ...styles.text, fontSize: "3rem" }}>
                        {prestaError ? "Errore nella creazione su Prestashop" : "Richiesta rifiutata!"}
                    </MyText>
                    <div style={styles.circContainer}>
                        <img src={cross} alt="cross" />
                    </div>
                </div>
                <div style={{ ...styles.prosegui, backgroundColor: isHovered ? "red" : "transparent" }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={() => {
                        setRedScreen(false)
                        setIsHovered(false)
                    }}>
                    <MyText style={{...styles.text, fontFamily: 'Como-Bold'}}>Prosegui</MyText>
                </div>
            </div>
        )
    }

    if (greenScreen) {
        return (
            <div style={{ ...styles.redContainer, backgroundColor: "#00800080" }}>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <MyText style={{ ...styles.text, fontSize: "3rem" }}>
                        Richiesta approvata correttamente!
                    </MyText>
                    <div style={styles.circContainer}>
                        <img src={tick} alt="tick" />
                    </div>
                </div>
                <div style={{ ...styles.prosegui, backgroundColor: isHovered ? "green" : "transparent" }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={() => navigate("/")}>
                    <MyText style={{...styles.text, fontFamily: 'Como-Bold'}}>Prosegui</MyText>
                </div>
            </div>
        )
    }

    return (
        <div style={styles.container}>
            <Header path="/RegistraPacchetto" />
            <div style={{ ...styles.inputSection, marginTop: "2.5rem" }}>
                <Container style={styles.formContainer} align="start" fluid>
                    <Row justify="center" >
                        <Col md={4} justify="center" >
                            <div style={styles.field}>
                                <MyText style={styles.fieldTitle}>Cliente</MyText>
                                <MyText style={styles.fieldValue}>{client.label}</MyText>
                            </div>
                        </Col>
                        <Col md={4} align="start" >
                            <div style={styles.field}>
                                <MyText style={styles.fieldTitle}>Pacchetto</MyText>
                                <MyText style={styles.fieldValue}>{name}</MyText>
                            </div>
                        </Col>
                        <Col md={4} align="start" >
                            <div style={styles.field}>
                                <MyText style={styles.fieldTitle}>Categoria</MyText>
                                <MyText style={styles.fieldValue}>{cat}</MyText>
                            </div>
                        </Col>
                    </Row>
                    <br />
                    <Row justify="start" >
                        <Col md={4} align="start" >
                            <div style={styles.field}>
                                <MyText style={styles.fieldTitle}>Descrizione</MyText>
                                <MyText style={styles.fieldValue}>{removeHTMLTags(descrizione)}</MyText>
                            </div>
                        </Col>
                        <Col md={4} align="start" >
                            <div style={styles.field}>
                                <MyText style={styles.fieldTitle}>Riepilogo</MyText>
                                <MyText style={styles.fieldValue}>{removeHTMLTags(riepilogo)}</MyText>
                            </div>
                        </Col>
                        <Col md={4} align="start" >
                            <div style={styles.field}>
                                <MyText style={styles.fieldTitle}>Valore</MyText>
                                <MyText style={styles.fieldValue}>{importo.toFixed(2)} PP</MyText>
                            </div>
                        </Col>
                    </Row>
                    
                </Container>
            </div>
            <div style={styles.btnWrap}>
                <Button
                    img={cart}
                    text={`Registra pacchetto`}
                    callback={sendRequest}
                    textStyle={{ color: "white", fontSize: '1.2rem' }} 
                    style={styles.btn}/>
            </div>
        </div>);
}
const styles = {
    container: {
        height: '100%',
        flexDirection: 'column',
        backgroundColor: '#f2f2f2',
        overflowY: 'auto'
    },
    inputSection: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
    },
    formContainer:{
        width: "90%",
    },
    field: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        marginBottom: "2rem",
        alignItems: "start"
    },
    fieldTitle: {
        fontSize: '1.5rem',
        marginBottom: '0.5rem',
        fontFamily: 'Como-Bold',
        display: "flex",
        justifyContent: "center"
    },
    fieldValue: {
        fontSize: '1.5rem',
        display: "-webkit-box",
        WebkitLineClamp: 3,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        justifyContent: "center"
    },
    btnWrap: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: "5%",
        marginRight: "5%",
        // width: "0%",
    },
    redContainer: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        // backgroundColor: "#FF00007F"
    },
    circContainer: {
        backgroundColor: "transparent",
        height: "3rem",
        width: "3rem",
        borderRadius: "50%",
        marginLeft: "2rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: "3px solid white",
        boxSizing: "border-box"
    },
    prosegui: {
        marginTop: "1.5rem",
        borderRadius: "2rem",
        padding: "0.5rem 1.5rem",
        border: "2px solid white",
        cursor: "pointer"
    },
    text: {
        color: "white",
        fontSize: "1.5rem"
    }    
}
